/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { paginate } from '../../utils/paginate';
// import StudyContext from '../../context/study/studyContext';
import { FormContext } from '../../context/form/FormContext';
import { useAppContext } from '../../AppContext';
import Array from './Array'
// import { LanguageContext } from '../../context/language/LanguageContext';

const Questions = (props) => {
  const { globalState} = useAppContext();
    // const studyContext = useContext(StudyContext);
    // const {lang} = useContext(LanguageContext);
    // const { nextQuestion, estudio, ans, send, mensaje, lastPage, skips} = studyContext;
    // const alertaContext = useContext(AlertaContext);
    // const { mostrarAlerta, alerta } = alertaContext;

    // let history = useHistory()

    // Redireccionar en el submit
	// useEffect(() => {
	// 	if(send) history.push("/finish")
		// if(mensaje) mostrarAlerta(mensaje.msg, mensaje.categoria);
	// }, [mensaje, send]);


  window.addEventListener('beforeunload', (event) => {
    event.preventDefault();
    localStorage.clear()
  });

    // const {name, displayName, items, _id} = estudio;
  
    // const [elements, setElements] = useState(estudio);
    const [elements,setElements] = useState(
      {
        "answers": globalState.questions
      }
    )


    const { answers } = elements ?? {}

    const handleChange = async(_id, event) => {
        const newElements = { ...elements }
        newElements.answers.forEach(item => {
          const { type, id, answers = []} = item;
          if (_id === id) {
            switch (type) {
              case 'image_choice_multiple':
              case 'multiple_choice':
                item['next'] = true
                if (!item.answers) item.answers = []
                if (item.answers && !item.answers.includes(event.target.value)) {
                  item['answers'] = [...answers, event.target.value ]
                }else{
                  item['answers'] = answers.filter(answer => answer !== event.target.value)
                }
                break;

              case 'ranking':
                item['answersR'] = event
                break;
              
              case 'link_content': 
              case 'video_content':
                item['answer'] = true
                break;

              case 'scale':
              case 'scale_nps':
              case 'scale_smileys':
                item['answer'] = parseInt(event.target.value);
              break;

              case 'link_question':
              case 'video_question':
                  item['subtype'] = event.subtype
                  if (event.subtype === 'videoQuestionText') {
                    item['answer'] = event.target.value
                    item['file'] = null
                    return
                  }
                  item['file'] = event.target.value
                  item['answer'] = null
              break;

              case 'single_choice':
                // let jump = false;
                // const jumpTo = answers.filter(answer => answer.jumpTo)
                // if(jumpTo){
                //   let salto = jumpTo.find(a => a.label === event.target.value)
                //   if(salto) {
                //     item['jumpHasta'] = salto.jumpTo;
                //     jump = true;
                //   }else {
                //     jump = false
                //     item['jumpHasta'] = false;
                //   }
                //   }
                // item['jumpTo'] = jump;
                item['answer'] = event.target.value; 
                break;

                case 'image_answer':
                  item['answers'] =  event.target.value
                  item['files'] =  event.target.value
                  break;

                case 'video':
                  item['dialTesting'] =  event.target.value
                  break;
                case 'video_recording':
                  if(event.target.value.name !== undefined){
                    if(event.target.value.name.includes(id)){
                      item['answer'] =  event.target.value
                    }else{
                      item['answer'] = undefined
                    } 
                  }
                  break;

                case 'category':
                  item['answers'] =  event; //.target.value
                  break;

              default:
                item['answer'] = event.target.value;
                break;
            }
          }
          setElements(newElements);
        });

        // if(!typesSaved.includes(typeQuestion)){
        //   await nextQuestion({...elements, currentPage, skips: stepPages, language: lang, respondentName: estudio.firstName}, (id) => null)
        // }
      }

    const data = answers

    const itemsInPage = 1;
    // Establece el número de página a mostrar
    const [currentPage, setCurrentPage] = React.useState(1);
    // REGRESA UN ARREGLO DE TAMAÑO 1 (items por página) en la página inicial (1)
    // y se pasa al estado inicial del arreglo paginado
    const paginatedItems = paginate(data, itemsInPage, currentPage);
    // Variable de estado para guardar los items (paginados) a mostrar
    const [itemsPaginated, setItemsPaginated] = React.useState(paginatedItems);
    // Se establece el número de páginas máximo para evitar
    // renderizar elementos undefined
    const currentMaxPages = React.useRef(0);
    // UseRef debido al cambio de estado si llega un array de diferente longitud
    currentMaxPages.current = Math.ceil(data.length / itemsInPage);
  
    // Cambiar el estado del item renderizado de acuerdo a la página actual
    React.useEffect(() => {
      setItemsPaginated(paginate(data, itemsInPage, currentPage));
    }, [currentPage, data]); // data debe ser incluido si es un fetch desde servidor

    //ultima pregunta vista en estudio previo
    // useEffect(() => {
    //   if(lastPage) setCurrentPage(lastPage)
    // }, [lastPage]);

    // Datos para render
    // const { id, jumpTo, jumpHasta} = itemsPaginated[0];
    const [stepPages, setStepPages] = React.useState([]);
    
    // useEffect(()=>{
    //   if (skips) setStepPages(skips)
    // }, [skips])

    // React.useEffect(() => {
    //   let page = currentPage
    //   let np = jumpHasta + 1
    //   let skip = jumpHasta - page
    //   // let upd = ''
    //   if(jumpTo && stepPages.find(a => a[0] === page) && stepPages.find(a => a[1] !== jumpHasta)){
    //     let i = stepPages.findIndex(a => a[0] === page)
    //     let nw = [...stepPages]
    //     nw[i] = [page, skip, np]
    //     setStepPages(nw)
    //   }else if(jumpTo && !stepPages.includes(a => a[0] === page)){
    //     setStepPages([...stepPages, [page, skip, np]])
    //   }
    //   else if(!jumpTo && stepPages.find(a => a[0] === page)){
    //     setStepPages(stepPages.filter(item => item[0] !== page))
    //   }  
    // },[jumpTo, currentPage, jumpHasta])
    return ( 
        <FormContext.Provider value={{ handleChange }}>
          <div>
                {/* { alerta ? ( <div className={`alerta ${alerta.categoria}`}> {alerta.msg} </div> )  : null } */}
                <Array
                  // name={name}
                  // displayName={displayName}
                  text={itemsPaginated[0]}
                  limitPage={currentMaxPages.current}
                  currentPage={currentPage}
                  elements={elements}
                  stepPages={stepPages}
                  // jumpTo={jumpTo}
                  // id={id}
                  setCurrentPage={setCurrentPage} 
                  setStepPages={setStepPages}
                />
          </div>
        </FormContext.Provider>
    );
}
 
export default Questions;
